import { Menu, MenuItem, IconButton } from "@mui/material";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import {
  EnvironmentVariables,
  OrganizationTierTypes,
  PermissionLevel,
  PermissionsEnum,
  SettingsListProps,
} from "@/modules/common/types";
import { PathConstants } from "@/routes/constants";
import FeatureRouter from "@/modules/common/components/layout/side-menu/old-navbar/feature-router";
import SettingsIcon from "@/assets/icons/side-menu/settings-Icon";

export const SettingsList = ({
  anchorEl,
  handleClose,
  handleItemClick,
  handleOpen,
}: SettingsListProps) => {
  const isOpen = Boolean(anchorEl);

  return (
    <>
      <IconButton onClick={handleOpen} color="inherit">
        <SettingsIcon width={26} height={26} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: 200,
            },
          },
        }}
      >
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.COMMON_SETTINGS,
              level: PermissionLevel.READ,
            },
          ]}
        >
          <>
            <MenuItem onClick={() => handleItemClick(PathConstants.STATUSES)}>
              Statuses
            </MenuItem>
            <MenuItem onClick={() => handleItemClick(PathConstants.CATEGORIES)}>
              Categories
            </MenuItem>
            <MenuItem onClick={() => handleItemClick(PathConstants.POOLS)}>
              Pools
            </MenuItem>
            <MenuItem onClick={() => handleItemClick(PathConstants.FUNNELS)}>
              Funnels
            </MenuItem>

            <FeatureRouter
              featureKey="lead-icons"
              element={
                <MenuItem
                  onClick={() => handleItemClick(PathConstants.LEAD_ICONS)}
                >
                  Lead Icons
                </MenuItem>
              }
            />

            <PermissionGuard
              permissions={[
                {
                  name: PermissionsEnum.LEAD_TAGS,
                  level: PermissionLevel.READ,
                },
              ]}
            >
              <MenuItem
                onClick={() => handleItemClick(PathConstants.LEAD_TAGS)}
              >
                Lead Tags
              </MenuItem>
            </PermissionGuard>

            <MenuItem
              onClick={() => handleItemClick(PathConstants.CONFIGURATIONS)}
            >
              Configurations
            </MenuItem>

            <MenuItem
              onClick={() => handleItemClick(PathConstants.AI_CONFIGURATIONS)}
            >
              AI Configurations
            </MenuItem>

            <FeatureRouter
              featureKey="payment_plans"
              element={
                <MenuItem
                  onClick={() => handleItemClick(PathConstants.PAYMENT_PLANS)}
                >
                  Payment Plans
                </MenuItem>
              }
            />
          </>
        </PermissionGuard>

        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.TARGETS_CONFIGURATIONS_PAGE,
              level: PermissionLevel.READ,
            },
          ]}
        >
          <MenuItem
            onClick={() =>
              handleItemClick(PathConstants.DISPLAY_ORGANIZATIONS_TARGETS)
            }
          >
            Target Configurations
          </MenuItem>
        </PermissionGuard>

        <MenuItem
          onClick={() => handleItemClick(PathConstants.AUTO_ASSIGNMENT_POOLS)}
        >
          Auto Assignment Pools
        </MenuItem>

        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.FACEBOOK_RULES,
              level: PermissionLevel.READ,
            },
          ]}
        >
          <MenuItem
            onClick={() => handleItemClick(PathConstants.FACEBOOK_RULES)}
          >
            Facebook Rules
          </MenuItem>
        </PermissionGuard>

        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.USERS_PAGE,
              level: PermissionLevel.READ,
            },
          ]}
        >
          <MenuItem onClick={() => handleItemClick(PathConstants.USERS)}>
            Users
          </MenuItem>
        </PermissionGuard>


        <MenuItem
          onClick={() =>
            handleItemClick(PathConstants.SETTINGS)
          }
        >
          Settings
        </MenuItem>

        {EnvironmentVariables.COMPANY_NAME.toString() ===
          OrganizationTierTypes.NAWY && (
          <MenuItem
            onClick={() =>
              handleItemClick(PathConstants.PROPERTY_TRACK_SETTINGS)
            }
          >
            Property Tracker
          </MenuItem>
        )}
        {EnvironmentVariables.COMPANY_NAME.toString() ===
          OrganizationTierTypes.NAWY && (
          <MenuItem
            onClick={() =>
              handleItemClick(PathConstants.INTERESTS_CONFIGURATION)
            }
          >
            Interests
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
